<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资源中心</el-breadcrumb-item>
        <el-breadcrumb-item>充电桩管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <!--      搜索视图      -->
            <search
              :searchForm="searchForm"
              :stationsForSelect="stationsForSelect"
              :operatorForSelect="operatorForSelect"
              :operatorTree="operatorTree"
              :searchLoading="searchLoading"
              @submitSearchForm="submitSearchForm"
              @operatorSelect="operatorSelect"
              ref="searchForm"
            >
            </search>
<!--            <el-form>
              <el-col :span="2" class="diy-class">
                <el-form-item>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pileAdd"
                    icon="el-icon-plus"
                    class="el-btn"
                    v-if="checkPermission(['bee:res:pile:saveOrUpdatePile'])"
                  >
                    新增充电桩
                  </el-button>
                </el-form-item>
              </el-col>
            </el-form>-->
            <!--列表数据-->
            <el-tab-pane label="充电桩管理" name="stationList">
              <!--      列表组件       -->
              <list
                :pileDataTable="pileDataTable"
                :listLoading="listLoading"
                @showViewVisible="showViewVisible"
                @pileEdit="pileEdit"
                @pileDelete="pileDelete"
              ></list>
              <!-- 分页组件 -->
              <Pagination
                v-bind:child-msg="pageparam"
                @callFather="changePage"
              ></Pagination>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <!-- 编辑组件 -->
      <add
        :editForm="editForm"
        :editFormVisible="editFormVisible"
        :checkConnectionData="enumData.checkConnectionData"
        :togetherData="enumData.togetherData"
        :operatorForSelect="operatorForSelect"
        :operatorTree="operatorTree"
        :stationsForSelect="stationsForSelect"
        :pileTypeForSelect="pileTypeForSelect"
        :fastOrSlowData="enumData.fastOrSlowData"
        :pileTypeData="enumData.pileTypeData"
        :interfaceStandardData="enumData.interfaceStandardData"
        :protocolData="enumData.protocolData"
        :auxiliarySourceTypeData="enumData.auxiliarySourceTypeData"
        :editSubmitLoading="editSubmitLoading"
        @closeEditForm="closeEditForm"
        @editSubmit="editSubmit"
        @operatorSelect="operatorSelect"
        @stationSelect="stationSelect"
        @pileTypeSelect="pileTypeSelect"
      ></add>
      <!--   视图组件   -->
      <customizeView
        ref="customizeView"
        :view-visible="viewVisible"
        :detailForm="detailForm"
        :bindingRateForm="bindingRateForm"
        :serviceBillingRulesSelect="serviceBillingRulesSelect"
        :serviceBillingRulesIdTemp="serviceBillingRulesIdTemp"
        :runStatusData="enumData.runStatusData || []"
        @unbinding="unbinding"
        @dobinding="dobinding"
        @saveRunStatus="saveRunStatus"
        @closeView="viewVisible = false"
      ></customizeView>
    </el-main>
  </el-container>
</template>

<script>
import Pagination from "../../../components/Pagination";
import pileApi from "../../resourceCenter/api/pileApi";
import commonApi from "../../resourceCenter/api/commonApi";
import search from "./deviceManager/search";
import list from "./deviceManager/list";
import customizeView from "./deviceManager/customizeView";
import add from "./deviceManager/add";

export default {
  name: "deviceManager",
  data() {
    return {
      enumData: [
        {
          enabledStateFlagData: "",
          checkConnectionData: "",
          togetherData: "",
          runStatusData: "",
          isCecData: "",
          fastOrSlowData: "",
          protocolData: "",
          interfaceStandardData: "",
          auxiliarySourceTypeData: "",
        },
      ],
      stationsForSelect: "",
      operatorForSelect: "",
      operatorTree: [],
      pileTypeForSelect: "",
      activeName: "stationList",
      showFilters: true,
      listLoading: false,
      pileDataTable: [{}],
      // 多选集合
      pileDataSelection: [],
      // 查询
      searchLoading: false,
      searchFormVisible: false,
      searchForm: {
        // 未初始化不传递参数，影响后台接查询
      },
      // 编辑
      editFormVisible: false,
      editSubmitLoading: false,
      viewVisible: false, // 视图
      editForm: {},

      // 详情
      detailForm: {},
      viewName: "detailForm",
      formLabelWidth: "150px",

      // 分页参数
      pageparam: {
        t: {},
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      activeNames: [
        "basicInformation",
        "bindingInformation",
        "dateInformation",
      ],
      bindingRateForm: {},
      serviceBillingRulesSelect: {},
      serviceBillingRulesIdTemp: "",
    };
  },
  methods: {
    resetSearchForm() {
      this.searchForm = {};
    },
    submitSearchForm() {
      this.$refs.searchForm.$children[0].validate((valid) => {
        if (!valid) {
          return;
        }
        this.searchLoading = true;
        this.listLoading = true;
        // let param = Object.assign({}, this.stationSearchForm)
        // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
        this.searchForm.operatorId=sessionStorage.getItem('operatorId');
        this.pageparam.t = this.searchForm;
        let param = Object.assign({}, this.pageparam);
        pileApi.getPiles(param).then((res) => {
          if (res.code === 0) {
            this.pageparam.total = res.data.total;
            this.pileDataTable = res.data.records;
            // this.$message({
            //   message: res.message,
            //   type: 'success'
            // });
          } else {
            // this.$message.error(res.message);
          }
          this.searchLoading = false;
          this.listLoading = false;
        });
      });
    },
    // 多选
    pileDataSelectionChange(val) {
      this.pileDataSelection = val;
    },
    pileAdd() {
      this.$nextTick(() => {
        this.editFormVisible = true;
        this.editForm = Object.assign({
          protocol: "winline-0",
          auxiliarySourceType: "3",
          checkConnection: "Y",
          together: "N",
          fastOrSlow: "F",
          chargingInterface: "GB2015",
          enabledStateFlag: "Y",
          installDate: this.getNowTime(),
          produceDate: this.getNowTime(),
          /*freeOperatingTime: this.getNowTime(),*/
        });
      });
    },
    showViewVisible(index, row) {
      this.detailForm = Object.assign({}, row);
      this.pileTypeSelect(row.pileTypeId, this.detailForm);
      this.bindingRate(index, row);
      this.viewVisible = true;
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = " 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}${hour}`;
      console.log(defaultDate);
      return defaultDate;
    },
    closeEditForm() {
      this.editFormVisible = false;
    },
    pileEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.pileTypeSelect(row.pileTypeId, this.editForm);
      console.log(row);
      this.editForm.enabledStateFlag = this.editForm.enabledStateFlagCode;
      this.editForm.checkConnection = this.editForm.checkConnectionCode;
      this.editForm.together = this.editForm.togetherCode;
      this.editForm.runStatus = this.editForm.runStatusCode;
      this.editForm.isCec = this.editForm.isCecCode;
      this.editForm.currentType = this.editForm.currentTypeCode;
      this.editForm.fastOrSlow = this.editForm.fastOrSlowCode;
      // this.editForm.protocol = this.editForm.protocolCode;
      this.editForm.protocolVersion = this.editForm.protocolVersion
        ? this.editForm.protocolVersion
        : 0;
      this.editForm.protocol =
        this.editForm.protocolCode + "-" + this.editForm.protocolVersion;
      this.editForm.chargingInterface = this.editForm.interfaceStandardEnumCode;
      this.editForm.auxiliarySourceType = this.editForm.aAxiliarySourceTypeCode;
    },
    editSubmit(editForm) {
      editForm.validate((valid) => {
        if (!valid) {
          return;
        } else {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editSubmitLoading = true;
            let param = JSON.parse(JSON.stringify(this.editForm));
            param.protocolVersion = this.editForm.protocol.substring(this.editForm.protocol.length - 1);
            param.protocol = this.editForm.protocol.substring(0, this.editForm.protocol.length - 2);
            param = JSON.stringify(param);
            pileApi
              .saveOrUpdatePile(param)
              .then((res) => {
                this.editSubmitLoading = false;
                if (res.code === 0) {
                  // this.$message({
                  //   message: res.message,
                  //   type: 'success'
                  // });
                  this.editForm.protocolVersion = this.editForm.protocol.substring(
                    this.editForm.protocol.length - 1
                  );
                  this.editForm.protocol = this.editForm.protocol.substring(
                    0,
                    this.editForm.protocol.length - 2
                  );

                  this.editFormVisible = false;
                  this.submitSearchForm();
                } else {
                  // this.$message.error(res.message);
                }
              })
              .catch((error) => {
                this.editSubmitLoading = false;
              });
          });
        }
      });
    },
    pileDelete(index, row) {
      this.$confirm("确定要删除：" + row.name + "吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          pileApi.deletePile(row.id).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.submitSearchForm();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    changePage() {
      this.submitSearchForm();
    },
    // 加载下拉框
    loadSelectItem() {
      pileApi.getPileEnum().then((res) => {
        this.enumData.enabledStateFlagData = JSON.parse(
          res.enabledStateFlagData
        );
        this.enumData.checkConnectionData = JSON.parse(res.checkConnectionData);
        this.enumData.togetherData = JSON.parse(res.checkConnectionData);
        this.enumData.runStatusData = JSON.parse(res.runStatusData);
        this.enumData.isCecData = JSON.parse(res.isCecData);
        this.enumData.fastOrSlowData = JSON.parse(res.fastOrSlowData);
        this.enumData.protocolData = JSON.parse(res.protocolData);
        this.enumData.interfaceStandardData = JSON.parse(
          res.interfaceStandardData
        );
        this.enumData.auxiliarySourceTypeData = JSON.parse(
          res.auxiliarySourceTypeData
        );
        this.enumData.pileTypeData = [{"value":"Q","message":"汽车"}]
      });
      //let operatorId = this.$store.getters.operatorIds;
      let operatorId = sessionStorage.getItem('operatorId');
      commonApi.stationsForSelectByOperatorId([operatorId]).then((res) => {
        if (res.code === 0) {
          this.stationsForSelect = res.data;
        }
      });
      // 运营商下拉框
      commonApi.getOperatorsTree().then((res) => {
        if (res.code === 0) {
          this.operatorTree = res.data;
        }
      });
      pileApi.pileTypeForSelect().then((res) => {
        if (res.code === 0) {
          this.pileTypeForSelect = res.data;
        }
      });
    },
    operatorSelect(val) {
      commonApi.stationsForSelectByOperatorId([val]).then((res) => {
        if (res.code === 0) {
          this.stationsForSelect = res.data;
        }
      });
    },
    // 编辑场站选中时
    stationSelect(val) {
      commonApi.pilesForSelect(val).then((res) => {
        if (res.code === 0) {
          this.pilesForSelect = res.data;
        }
      });
    },
    pileTypeSelect(val, form) {
      for (let i = 0; i < this.pileTypeForSelect.length; i++) {
        if (val === this.pileTypeForSelect[i].id) {
          form.gunCount = this.pileTypeForSelect[i].gunCount;
          form.ratedPower = this.pileTypeForSelect[i].ratedPower;
          form.outputCurrentRange = this.pileTypeForSelect[
            i
          ].outputCurrentRange;
          form.interfaceStandard = this.pileTypeForSelect[i].interfaceStandard;
        }
      }
    },
    // 显示绑定费率页面
    bindingRate(index, row) {
      this.bindingRateForm = {
        id: row.id,
        serviceBillingRulesId: row.serviceBillingRulesId,
        ruleName: "",
        operatorId: row.operatorId,
      };
      // console.log(row.serviceBillingRulesId)
      if (this.bindingRateForm.serviceBillingRulesId) {
        // 若果已经绑定了费率，则查询费率名称，显示解绑页面
        pileApi
          .getRateNameById(this.bindingRateForm.serviceBillingRulesId)
          .then((res) => {
            this.bindingRateForm.ruleName = res.ruleName;
          });
      } else {
        // 如果没有绑定费率，则查询运营商关联的费率列表，显示绑定页面
        // 获取当前登陆/或选择的运营商ID
        pileApi
          .getRateSelectByOperatorId([this.bindingRateForm.operatorId])
          .then((res) => {
            this.serviceBillingRulesSelect = res;
          });
      }
    },
    // 解绑费率
    unbinding() {
      // console.log(this.bindingRateForm)
      this.$confirm(
        "确定要解绑 " + this.bindingRateForm.ruleName + " 吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let param = Object.assign({}, this.bindingRateForm);
          param.serviceBillingRulesId = null;
          pileApi.bindingRate(param).then((res) => {
            if (res) {
              this.$message({
                message: "解绑成功",
                type: "success",
              });
              pileApi
                .getRateSelectByOperatorId([this.bindingRateForm.operatorId])
                .then((res) => {
                  this.serviceBillingRulesSelect = res;
                });
              this.bindingRateForm.serviceBillingRulesId = null;
              this.submitSearchForm();
              this.viewVisible = false;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作！",
          });
        });
    },
    // 视图中保存桩运行状态
    saveRunStatus(payload) {
      if (!payload || !payload.id) {
        this.$message.error("充电桩信息缺失");
        return;
      }
      this.$confirm("确认保存桩运行状态吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.$refs.customizeView) {
            this.$refs.customizeView.setRunStatusSaving(true);
          }
          const matched = (this.enumData.runStatusData || []).find(
            (item) => item.value === payload.runStatus || item.value === Number(payload.runStatus)
          );
          const param = {
            id: payload.id,
            runStatus: payload.runStatus,
            runStatusRemark: payload.runStatusRemark || (matched && matched.message) || "",
          };
          pileApi
            .editPile(param)
            .then((res) => {
              if (this.$refs.customizeView) {
                this.$refs.customizeView.setRunStatusSaving(false);
              }
              if (res && res.code === 0) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.detailForm.runStatusCode = param.runStatus;
                this.detailForm.runStatusRemark = param.runStatusRemark;
                this.detailForm.runStatus = {
                  code: param.runStatus,
                  message: param.runStatusRemark,
                };
                this.submitSearchForm();
              } else {
                this.$message.error((res && res.message) || "保存失败");
              }
            })
            .catch(() => {
              if (this.$refs.customizeView) {
                this.$refs.customizeView.setRunStatusSaving(false);
              }
            });
        })
        .catch(() => {});
    },
    // 绑定费率
    dobinding(bindingRateForm) {
      console.log("this.bindingRateForm.serviceBillingRulesIdTemp");
      console.log(this.bindingRateForm.serviceBillingRulesIdTemp);
      bindingRateForm.validate((valid) => {
        if (!valid) {
          return;
        } else {
          // console.log(this.$refs.bindSelect.$el.innerHTML)
          this.$confirm("确定要绑定吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let param = Object.assign({}, this.bindingRateForm);
              param.serviceBillingRulesId = this.bindingRateForm.serviceBillingRulesIdTemp;
              pileApi.bindingRate(param).then((res) => {
                if (res) {
                  this.$message({
                    message: "绑定成功",
                    type: "success",
                  });
                  pileApi
                    .getRateNameById(
                      this.bindingRateForm.serviceBillingRulesIdTemp
                    )
                    .then((res) => {
                      this.bindingRateForm.ruleName = res.ruleName;
                    });
                  this.bindingRateForm.serviceBillingRulesId = this.bindingRateForm.serviceBillingRulesIdTemp;
                  this.submitSearchForm();
                  this.viewVisible = false;
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作！",
              });
            });
        }
      });
    },
  },
  components: {
    Pagination,
    search,
    list,
    customizeView,
    add,
  },
  created: function () {
    this.loadSelectItem();
  },
  mounted: function () {
    this.submitSearchForm();
  },
  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this.searchForm.stationId=''
        this.loadSelectItem()
        this.submitSearchForm()
      },
      deep: true
    }
  },

  filters: {
    statusFilter(runStatus) {
      const statusMap = {
        0: "success",
        1: "info",
        2: "danger",
        3: "warning",
      };
      return statusMap[runStatus];
    },
  },
};
</script>
<style lang="less" scoped>
.el_search {
  background-color: teal;
  color: white;
}

.el_clear {
  background-color: darkorange;
  color: white;
}
/deep/.el-dialog {
  width: 900px;
}
/deep/ .edit_form,
/deep/ .detail_form,
/deep/ .bindingRateForm {
  height: 600px;
  overflow: auto;

  .el-form-item__label {
    color: rgba(0, 0, 0, 0.47);
  }
}
/deep/ .diy-class {
  .el-form-item__content {
    line-height: 0px;
  }
}
.bindingRateForm {
  text-align: left;
}
</style>





// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager.vue